// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"0a972d23","531":"e98d7638","585":"03aee0af","626":"81a932e5","656":"9aab0a29","677":"cb32b279","927":"57fe12d1"}[chunkId] + ".chunk.js";
};